import React, { useState } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { FormFieldDataAvailability, FormFieldDateInput, FormFieldRadio, FormFieldTextInput } from '@publishing-engine/domain/types/article';
import { IDependentValue, ISubmission } from '@publishing-engine/domain/models';
import { Banner, ButtonText } from '@morressier/alembic';
import EditModal from './EditModal.js';

interface Props {
  config: FormFieldDataAvailability;
  isEditAllowed?: boolean;
  data?: IDependentValue<string>;
  onSubmit?: (value: Partial<ISubmission>) => void;
  DataAvailabilityOpenlyAvailableUrlConfig?: FormFieldTextInput<'preference.dataAvailabilityOpenlyAvailableUrl'>;
  DataAvailabilityEmbargoUrlConfig?: FormFieldTextInput<'preference.dataAvailabilityEmbargoUrl'>;
  DataAvailabilityEmbargoDateConfig?: FormFieldDateInput<'preference.dataAvailabilityEmbargoDate'>;
  DataUnavailabilityReasonConfig?: FormFieldRadio<'preference.dataUnavailabilityReason'>;
}

const DataAvailability: React.FC<Props> = ({
  data,
  isEditAllowed,
  config,
  onSubmit = () => {},
  DataAvailabilityOpenlyAvailableUrlConfig,
  DataAvailabilityEmbargoUrlConfig,
  DataAvailabilityEmbargoDateConfig,
  DataUnavailabilityReasonConfig
}) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const text = data?.value || '';
  const subText = config.params.labels.dependentOptions?.[text]?.main;

  return (
    <>
      {isEditing && isEditAllowed && (
        <EditModal
          onClose={() => setIsEditing(false)}
          defaultValue={data}
          isOpen={isEditing}
          onSave={onSubmit}
          config={config}
          DataAvailabilityOpenlyAvailableUrlConfig={DataAvailabilityOpenlyAvailableUrlConfig}
          DataAvailabilityEmbargoUrlConfig={DataAvailabilityEmbargoUrlConfig}
          DataAvailabilityEmbargoDateConfig={DataAvailabilityEmbargoDateConfig}
          DataUnavailabilityReasonConfig={DataUnavailabilityReasonConfig}
        />
      )}
      <Flex gap={2} flexDirection="column">
        <Text textStyle="headingGroup">Data Availability</Text>
        {!data?.exists ? (
          <Text textStyle="textBody">Data is publicly available</Text>
        ) : (
          <Banner variant="attention" heading={text} content={subText} />
        )}
        {isEditAllowed && (
          <ButtonText
            variant="primary"
            onClick={() => setIsEditing(true)}
            alignSelf={'flex-start'}
          >
            Update Data Availability
          </ButtonText>
        )}
      </Flex>
    </>
  );
};

export default DataAvailability;
